export enum CadNames {
  onScene = "On Scene",
  jobFinished = "Job Finished",
  enRoute = "En-Route",
  inService = "In Service",
  labs = "Labs",
  atDestination = "At Destination",
  atPatientSide = "At Patient Side",
  tranporting = "Transporting",
  released = "Released",
  treatedAndReleased = "Treated and Released",
}

export const CadStatusColors: Record<string, string> = {
  "En-Route": "#dc3545",
  "On Scene": "#198754",
  Labs: "#ffbf00",
  "Job Finished": "#d3d3d3",
  Released: "#d3d3d3",
  Dispatched: "#dc3545",
  "On-Going Treatment": "#198754",
  "Transported to ED": "#004400",
  "Treated and Released": "#d3d3d3",
};
